import type { FunctionComponent } from 'react';

import { useFeatureFlag } from '@trello/feature-flag-client';
import { ListTestIds } from '@trello/test-ids';

import styles from './ListColorPickerSkeleton.less';

export const ListColorPickerSkeleton: FunctionComponent = () => {
  const shouldShowFeedbackButton = useFeatureFlag('atlassian-team', false);
  return (
    <div data-testid={ListTestIds.ListColorPickerSkeleton}>
      <div className={styles.header} />
      <div className={styles.row} />
      <div className={styles.row} />
      {shouldShowFeedbackButton && <div className={styles.feedbackButton} />}
    </div>
  );
};
